"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var pkg_cruise_api_endpoint_1 = require("pkg-cruise-api-endpoint");
var client_1 = require("../config/client");
// tslint:disable-next-line:max-classes-per-file
var Carol = /** @class */ (function (_super) {
    __extends(Carol, _super);
    function Carol() {
        return _super.call(this, pkg_cruise_api_endpoint_1.stage, client_1.endpointMapping) || this;
    }
    Object.defineProperty(Carol.prototype, "language", {
        set: function (langVal) {
            this.settedLanguage = langVal;
        },
        enumerable: false,
        configurable: true
    });
    Carol.prototype.i18n = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            var language, params, pathTemplate, query;
            return __generator(this, function (_a) {
                language = lang || this.settedLanguage || 'de';
                params = {};
                pathTemplate = '/i18n';
                query = { language: language };
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Carol.prototype.justCabinDescription = function (ships, cabinCategory) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { ships: ships.join(','), cabinCategory: cabinCategory };
                pathTemplate = '/justCabinDescription/{cabinCategory}/{ships}';
                query = {};
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Carol.prototype.cabin = function (shipCode, cabinId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documentWithSecondaryId('cabins', shipCode, cabinId)];
            });
        });
    };
    Carol.prototype.cruises = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('cruises', FilterConfig)];
            });
        });
    };
    Carol.prototype.cruise = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('cruises', id)];
            });
        });
    };
    Carol.prototype.regions = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.documents('regions', FilterConfig)];
                    case 1:
                        list = _a.sent();
                        return [2 /*return*/, (0, lodash_1.filter)(list, function (item) { return /^VR/.test(item.id); })]; // only these are understood by IBE
                }
            });
        });
    };
    Carol.prototype.region = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('regions', id)];
            });
        });
    };
    Carol.prototype.countries = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('countries', FilterConfig)];
            });
        });
    };
    Carol.prototype.country = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('countries', id)];
            });
        });
    };
    Carol.prototype.additions = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('additions', FilterConfig)];
            });
        });
    };
    Carol.prototype.addition = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('additions', id)];
            });
        });
    };
    Carol.prototype.articles = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('content-hub-articles', FilterConfig)];
            });
        });
    };
    Carol.prototype.article = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('content-hub-articles', id)];
            });
        });
    };
    Carol.prototype.personae = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('personae', FilterConfig)];
            });
        });
    };
    Carol.prototype.persona = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('personae', id)];
            });
        });
    };
    Carol.prototype.ships = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('ships', FilterConfig)];
            });
        });
    };
    Carol.prototype.ship = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('ships', id)];
            });
        });
    };
    Carol.prototype.routes = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('routes', FilterConfig)];
            });
        });
    };
    Carol.prototype.route = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('routes', id)];
            });
        });
    };
    Carol.prototype.ports = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('ports', FilterConfig)];
            });
        });
    };
    Carol.prototype.port = function (id, secondaryIndexName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (secondaryIndexName === 'slug') {
                    id = id.toLowerCase();
                }
                return [2 /*return*/, this.document('ports', id, secondaryIndexName)];
            });
        });
    };
    Carol.prototype.airlines = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('airlines', FilterConfig)];
            });
        });
    };
    Carol.prototype.airline = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('airlines', id)];
            });
        });
    };
    Carol.prototype.airports = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('airports', FilterConfig)];
            });
        });
    };
    Carol.prototype.airport = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('airports', id)];
            });
        });
    };
    Carol.prototype.news = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('news', FilterConfig)];
            });
        });
    };
    Carol.prototype.newsItem = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('news', id)];
            });
        });
    };
    Carol.prototype.campaignAssets = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('campaign-media', FilterConfig)];
            });
        });
    };
    Carol.prototype.campaignAsset = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('campaign-media', id)];
            });
        });
    };
    Carol.prototype.campaignMappings = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('campaign-mapping', FilterConfig)];
            });
        });
    };
    Carol.prototype.checkInTimes = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cruise(id)];
                    case 1: return [2 /*return*/, (_a.sent()).checkInTimes];
                }
            });
        });
    };
    Carol.prototype.weatherStation = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('weather-stations', id)];
            });
        });
    };
    Carol.prototype.weatherStations = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('weather-stations', FilterConfig)];
            });
        });
    };
    Carol.prototype.campaignList = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('campaign-lists', id)];
            });
        });
    };
    Carol.prototype.campaignLists = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('campaign-lists', FilterConfig)];
            });
        });
    };
    Carol.prototype.careersContent = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('careers-content', id)];
            });
        });
    };
    Carol.prototype.careersContents = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('careers-content', FilterConfig)];
            });
        });
    };
    Carol.prototype.careersMainCategory = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('careers-main-categories', id)];
            });
        });
    };
    Carol.prototype.careersMainCategories = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('careers-main-categories', FilterConfig)];
            });
        });
    };
    Carol.prototype.careersJobDescription = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('careers-job-descriptions', id)];
            });
        });
    };
    Carol.prototype.careersJobDescriptions = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('careers-job-descriptions', FilterConfig)];
            });
        });
    };
    Carol.prototype.tariffsBenefit = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('tariffs-benefits', id)];
            });
        });
    };
    Carol.prototype.tariffsBenefits = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('tariffs-benefits', FilterConfig)];
            });
        });
    };
    Carol.prototype.tariffsCatalogue = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('tariffs-catalogue', id)];
            });
        });
    };
    Carol.prototype.tariffsCatalogues = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('tariffs-catalogue', FilterConfig)];
            });
        });
    };
    Carol.prototype.trackingPageCategory = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('tracking-page-categories', id)];
            });
        });
    };
    Carol.prototype.trackingPageCategories = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('tracking-page-categories', FilterConfig)];
            });
        });
    };
    Carol.prototype.redirect = function (id, secondaryIndexName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.document('seo-redirects', id, secondaryIndexName)];
            });
        });
    };
    Carol.prototype.redirects = function (FilterConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.documents('seo-redirects', FilterConfig)];
            });
        });
    };
    Carol.prototype.documents = function (name, config) {
        return __awaiter(this, void 0, void 0, function () {
            var params, preview, draft, select, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { name: name };
                preview = pkg_cruise_api_endpoint_1.preset.getPreviewToken();
                draft = pkg_cruise_api_endpoint_1.preset.getDraftId();
                select = config ? (0, lodash_1.join)(config.keys, ',') : undefined;
                pathTemplate = '/{name}';
                query = { preview: preview, draft: draft, select: select, language: this.settedLanguage };
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Carol.prototype.document = function (name, id, secondaryIndexName) {
        return __awaiter(this, void 0, void 0, function () {
            var preview, draft, params, pathTemplate, query;
            return __generator(this, function (_a) {
                preview = pkg_cruise_api_endpoint_1.preset.getPreviewToken();
                draft = pkg_cruise_api_endpoint_1.preset.getDraftId();
                params = { name: name, id: id, secondaryIndexName: secondaryIndexName };
                pathTemplate = '/{name}/{id}';
                query = { preview: preview, draft: draft, language: this.settedLanguage };
                if (secondaryIndexName) {
                    pathTemplate = '/{name}/index/{secondaryIndexName}/{id}';
                }
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Carol.prototype.documentWithSecondaryId = function (name, id, secondaryId) {
        return __awaiter(this, void 0, void 0, function () {
            var preview, draft, params, pathTemplate, query;
            return __generator(this, function (_a) {
                preview = pkg_cruise_api_endpoint_1.preset.getPreviewToken();
                draft = pkg_cruise_api_endpoint_1.preset.getDraftId();
                params = { name: name, id: id, secondaryId: secondaryId };
                pathTemplate = '/{name}/{id}/{secondaryId}';
                query = { preview: preview, draft: draft };
                return [2 /*return*/, this.invokeShortGET(params, pathTemplate, query)];
            });
        });
    };
    Carol.prototype.preset = function () {
        return pkg_cruise_api_endpoint_1.preset;
    };
    return Carol;
}(pkg_cruise_api_endpoint_1.Endpoint));
exports.default = Carol;
//# sourceMappingURL=carol.js.map